import { ValueFormatterParams } from 'ag-grid-community';

// An attribute column holds a part's values as a list, shown joined. A group row (Group By) has
// the list's own string form as its name, the values joined by a bare comma, shown the same way.
// No key creator: the column's set filter would then want one of its own and warn about the plain
// strings it is given.
export const formatAttributeValues = ({ value }: ValueFormatterParams): string =>
  (Array.isArray(value) ? value : String(value ?? '').split(','))
    .map((part) => String(part).trim())
    .join(', ');
